import { Box } from "@chakra-ui/react"
import ContactForm from "@components/Forms/ContactForm"
import ProductLayout from "@components/Layouts/ProductLayout"
import { getCurrentDomain } from "@utils/common"
import fs from "fs"
import {
  GetServerSideProps,
  GetServerSidePropsContext,
  InferGetServerSidePropsType,
} from "next"
import { MDXRemote } from "next-mdx-remote"
import { serialize } from "next-mdx-remote/serialize"
import { NextSeo } from "next-seo"
import path from "path"

const Page = ({
  domain,
  meta_title,
  meta_description,
  content,
  slug,
  date_updated,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  return (
    <ProductLayout>
      <NextSeo
        title={meta_title}
        canonical={`${domain}/g/${slug}`}
        description={meta_description}
      />
      {slug === "contact" && <ContactForm />}
      <Box>
        <MDXRemote {...content} />
        {date_updated && (
          <Box
            fontSize={"xs"}
            fontStyle={"italic"}
            mt={8}
          >
            {`Last Updated: ${date_updated}`}
          </Box>
        )}
      </Box>
    </ProductLayout>
  )
}

export default Page

export const getServerSideProps: GetServerSideProps = async ({
  params,
  res,
}: GetServerSidePropsContext) => {
  res.setHeader(
    "Cache-Control",
    "public, s-maxage=3600, stale-while-revalidate"
  )

  const slug = params?.slug
  const domain = getCurrentDomain()
  try {
    // Path to MD file
    const mdFilePath = path.join(
      process.cwd(),
      "src",
      "data",
      "pages",
      `${slug}.mdx`
    )

    // Read the content of the file
    const mdFileContent = fs.readFileSync(mdFilePath, "utf-8")

    if (!mdFileContent?.length || !mdFileContent) {
      return {
        notFound: true,
        revalidate: true,
      }
    }

    const content = await serialize(mdFileContent, { parseFrontmatter: true })

    const dateUpdated = content?.frontmatter?.date_updated
      ? new Date(
          content?.frontmatter?.date_updated as string
        ).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      : null

    return {
      props: {
        domain,
        meta_title: content?.frontmatter?.meta_title || null,
        meta_description: content?.frontmatter?.meta_description || null,
        content,
        slug: slug,
        date_updated: ["about", "contact"].includes(slug as string)
          ? null
          : dateUpdated,
      },
    }
  } catch (error) {
    console.error(error)
    return {
      notFound: true,
      revalidate: true,
    }
  }
}
